import NextImage from 'next/image'
import ApplePodcast from 'public/logo-cloud/apple-podcast.svg'
import Castbox from 'public/logo-cloud/castbox.svg'
import GooglePodcasts from 'public/logo-cloud/google-podcasts.svg'
import Overcast from 'public/logo-cloud/overcast.svg'
import Pocketcasts from 'public/logo-cloud/pocketcasts.svg'
import Spotify from 'public/logo-cloud/spotify.svg'
import Stitcher from 'public/logo-cloud/stitcher.svg'

const PodcastHighlight = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element => {
  return (
    <div
      className={`bg-neutral-7 p-2 rounded-12 lg:flex ${className || ''}`}
      {...props}
    >
      <div className='p-4 md:p-8 flex flex-col justify-between'>
        <p className='large-body-text'>
          In this podcast, we share our knowledge on the path of building a SaaS
          company. The podcast features the Stellate team and other industry
          experts and personalities in the startup world. This is the podcast we
          wished had existed when we started Stellate.
        </p>

        <div className='spacer-md'>
          <p className='label opacity-40'>Where to listen</p>

          <div className='spacer-3xs'>
            <ul className='flex flex-wrap -mt-6'>
              {links.map((link, index) => (
                <li
                  key={`podcast-highlight-link-${index}`}
                  className='mt-6 mr-6'
                >
                  <a
                    href={link.href}
                    className='flex items-center transition-opacity hover:opacity-80 focus:opacity-80'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {link.logo}

                    <small className='hidden md:block ml-2'>{link.name}</small>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className='mt-6 md:mt-0 flex justify-center items-center bg-white rounded-12'>
        <div className='relative max-w-[420px] lg:min-w-[360px] 2xl:min-w-[420px]'>
          <NextImage
            src='/future-founder-promise-podcast.webp'
            className='rounded-12'
            alt='Future Founder Promise Podcast cover art'
            width='1080'
            height='1080'
            priority
          />
        </div>
      </div>
    </div>
  )
}

const logoClasses = 'h-8 w-auto opacity-40'

const links: { name: string; logo: JSX.Element; href: string }[] = [
  {
    name: 'Spotify',
    logo: <Spotify className={logoClasses} />,
    href: 'https://open.spotify.com/show/3575WqPztaXLGPcfIBrkJI',
  },
  {
    name: 'Apple Podcasts',
    logo: <ApplePodcast className={logoClasses} />,
    href: 'https://podcasts.apple.com/us/podcast/future-founder-promise/id1622431816',
  },
  {
    name: 'Google Podcasts',
    logo: <GooglePodcasts className={logoClasses} />,
    href: 'https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy85M2VlYThhYy9wb2RjYXN0L3Jzcw',
  },
  {
    name: 'Castbox',
    logo: <Castbox className={logoClasses} />,
    href: 'https://castbox.fm/channel/id4922742?country=us',
  },
  {
    name: 'Overcast',
    logo: <Overcast className={logoClasses} />,
    href: 'https://overcast.fm/itunes1622431816',
  },
  {
    name: 'Pocketcasts',
    logo: <Pocketcasts className={logoClasses} />,
    href: 'https://pca.st/042lhxnd',
  },
  {
    name: 'Stitcher',
    logo: <Stitcher className={logoClasses} />,
    href: 'https://www.stitcher.com/podcast/future-founder-promise',
  },
]

export default PodcastHighlight
